import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Card } from "primereact/card";
import { userActions } from "../../store/user-store/user-slice";
import { GetCharges } from "../../store/charge-store/charge-actions";
import { GetDepartments } from "../../store/department-store/department-actions";
import { GetCompanies } from "../../store/company-store/company-actions";

import { isValidEmail } from "../../utils/ValidateUserInfo";
import { arregloPaises } from "../List";
import { useEffect, useState } from "react";

import "./UserFormDetail.css";
import { getTokenInfo } from "../../utils/Guard";
import Loading from "../UI/Loading";

const UserFormDetail = (props) => {
  const dispatch = useDispatch();
  const isValid = useSelector((state) => state.user.userValidation);
  const user = useSelector((state) => state.user.user);
  const charges = useSelector((state) => state.charge.charges);
  const departments = useSelector((state) => state.department.departments);
  const companies = useSelector((state) => state.company.companies);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const userInfo = getTokenInfo();

  useEffect(() => {
    if (departments === undefined || departments.length === 0) {
      dispatch(GetDepartments(userInfo.Email, true));
    }
  }, [userInfo.Email, departments, dispatch]);

  useEffect(() => {
    if (charges === undefined || charges.length === 0) {
      dispatch(GetCharges(userInfo.Email, true));
    }
  }, [userInfo.Email, dispatch, charges]);

  useEffect(() => {
    if (companies === undefined || companies.length === 0) {
      dispatch(GetCompanies(userInfo.Email, true));
    }
  }, [userInfo.Email, dispatch, companies]);

  useEffect(() => {
    if (
      user.country !== undefined &&
      user.country !== "" &&
      selectedCountry === null
    ) {
      const pais = arregloPaises.find((pais) => pais.nombre === user.country);
      setSelectedCountry({
        code: user.country,
        name: user.country,
        flag: pais !== undefined ? pais.abreviatura : "",
      });
    }
    if (
      user.charge !== undefined &&
      user.charge.id !== undefined &&
      selectedCharge === null
    ) {
      setSelectedCharge({
        code: user.charge.id,
        name: user.charge.name,
      });
    }
    if (
      user.department !== undefined &&
      user.department.id !== undefined &&
      selectedDepartment === null
    ) {
      setSelectedDepartment({
        code: user.department.id,
        name: user.department.name,
      });
    }
    if (
      user.company !== undefined &&
      user.company.id !== undefined &&
      selectedCompany === null
    ) {
      setSelectedCompany({
        code: user.company.id,
        name: user.company.name,
      });
    }
  }, [
    user.country,
    selectedCountry,
    user,
    selectedCharge,
    selectedDepartment,
    selectedCompany,
  ]);

  const onChangeHandler = (id, value) => {
    if (id === "charge" || id === "department" || id === "company") {
      if (id === "charge") {
        dispatch(
          userActions.modifyPropertyValue({
            id,
            value: { id: value.id, name: value.name },
          })
        );
        setSelectedCharge({
          code: value.code,
          name: value.name,
        });
      }
      if (id === "department") {
        dispatch(
          userActions.modifyPropertyValue({
            id,
            value: { id: value.code, name: value.name },
          })
        );
        setSelectedDepartment({
          code: value.code,
          name: value.name,
        });
      }
      if (id === "company") {
        dispatch(
          userActions.modifyPropertyValue({
            id,
            value: { id: value.code, name: value.name },
          })
        );

        setSelectedCompany({
          code: value.code,
          name: value.name,
        });
      }
    } else {
      dispatch(userActions.modifyPropertyValue({ id, value }));
      if (value !== "") {
        if (id === "email") {
          if (isValidEmail(value)) {
            dispatch(userActions.setFieldValid({ id, value: true }));
          } else {
            dispatch(userActions.setFieldValid({ id, value: false }));
          }
        } else if (
          id === "name" ||
          id === "lastName" ||
          id === "email" ||
          id === "cellPhone" ||
          id === "country"
        ) {
          dispatch(userActions.setFieldValid({ id, value: true }));
        }
      } else if (
        id === "name" ||
        id === "lastName" ||
        id === "email" ||
        id === "cellPhone" ||
        id === "country"
      ) {
        dispatch(userActions.setFieldValid({ id, value: false }));
      }
    }
  };
  const onChangeCountriesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedCountry({
      code: value.code,
      name: value.name,
      flag: value.flag,
    });
  };
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };

  const paises = arregloPaises.map((pais) => ({
    code: pais.nombre,
    name: pais.nombre,
    flag: pais.abreviatura,
  }));
  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <img
            alt={option.name}
            src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
            style={{ width: "18px" }}
          />

          <div style={{ marginLeft: "5%" }}>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const countryOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center" style={{ width: "100px" }}>
        <img
          alt={option.name}
          src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
          style={{ width: "18px" }}
        />
        <div style={{ marginLeft: "5%" }}>{option.name}</div>
      </div>
    );
  };

  return (
    <>
      <div className="card mb-4 ">
        <Card className="userFormDetailCard">
          <form onSubmit={props.onSubmitHandler}>
            <div className="formgrid grid">
              <div className="field col-12 md:col-12">
                <label htmlFor="name" className="userFormDetailLabel">
                  Nombres:
                </label>
                <InputText
                  id="name"
                  value={user.name}
                  onChange={(e) => onChangeHandler("name", e.target.value)}
                  placeholder="Nombres"
                  className="userFormDetailInput"
                />
                <div>{getFormErrorMessage("name")}</div>
              </div>
              <div className="field col-12 md:col-12">
                <label htmlFor="lastName" className="userFormDetailLabel">
                  Apellidos:
                </label>
                <InputText
                  id="lastName"
                  value={user.lastName}
                  onChange={(e) => onChangeHandler("lastName", e.target.value)}
                  placeholder="Apellidos"
                  className="userFormDetailInput"
                />
                <div>{getFormErrorMessage("lastName")}</div>
              </div>
              <div className="field col-12 md:col-12">
                <label htmlFor="Email" className="userFormDetailLabel">
                  Email:
                </label>
                <InputText
                  id="Email"
                  value={user.email}
                  onChange={(e) => onChangeHandler("email", e.target.value)}
                  placeholder="example@email.com"
                  className="userFormDetailInput"
                />
                <div>{getFormErrorMessage("email")}</div>
              </div>
              <div className="field col-12 md:col-12">
                <p className="userFormDetailMessage">
                  Es esencial que tengamos la dirección de correo electrónico
                  directa del inscrito, recibirá información importante
                  relacionada con su "licencia"
                </p>
              </div>

              <div className="field col-12 md:col-12">
                <label htmlFor="cellPhone" className="userFormDetailLabel">
                  Teléfono Celular:
                </label>
                <InputText
                  id="cellPhone"
                  value={user.cellPhone}
                  onChange={(e) => onChangeHandler("cellPhone", e.target.value)}
                  placeholder=""
                  className="userFormDetailInput"
                />
                <div>{getFormErrorMessage("cellPhone")}</div>
              </div>
            </div>
            <div className="field col-12 md:col-12">
              <label htmlFor="country" className="userFormDetailLabel">
                País:
              </label>
              <br />
              <Dropdown
                value={selectedCountry}
                onChange={(e) => {
                  onChangeCountriesHandler("country", e.value);
                }}
                options={paises}
                optionLabel="name"
                placeholder="Seleccionar pais"
                valueTemplate={selectedCountryTemplate}
                filter
                itemTemplate={countryOptionTemplate}
                className="userFormDetailDropdown"
              />
              <div>{getFormErrorMessage("country")}</div>
            </div>
            <h2 className="mt-3 fw-normal userFormDetailTitle">
              Información Laboral
            </h2>
            <div className="formgrid grid">
              {charges.length <= 0 && (
                <div className="field col-12 md:col-12">
                  <Loading />
                </div>
              )}
              {charges.length > 0 && (
                <div className="field col-12 md:col-12">
                  <label htmlFor="charge" className="userFormDetailLabel">
                    Cargo:
                  </label>
                  <Dropdown
                    id="cargo"
                    value={selectedCharge}
                    onChange={(e) => onChangeHandler("charge", e.value)}
                    options={charges}
                    optionLabel="name"
                    placeholder="Seleccionar cargo"
                    filter
                    className="userFormDetailDropdown"
                  />
                </div>
              )}

              {departments.length <= 0 && (
                <div className="field col-12 md:col-12">
                  <Loading />
                </div>
              )}
              {departments.length > 0 && (
                <div className="field col-12 md:col-12">
                  <label htmlFor="department" className="userFormDetailLabel">
                    Departamento:
                  </label>
                  <Dropdown
                    id="department"
                    value={selectedDepartment}
                    onChange={(e) => onChangeHandler("department", e.value)}
                    options={departments}
                    optionLabel="name"
                    placeholder="Seleccionar departamento"
                    filter
                    className="userFormDetailDropdown"
                  />
                </div>
              )}
              {companies.length <= 0 && (
                <div className="field col-12 md:col-12">
                  <Loading />
                </div>
              )}
              {companies.length > 0 && (
                <div className="field col-12 md:col-12">
                  <label htmlFor="company" className="userFormDetailLabel">
                    Empresa:
                  </label>
                  <Dropdown
                    id="Empresa"
                    value={selectedCompany}
                    onChange={(e) => onChangeHandler("company", e.value)}
                    options={companies}
                    optionLabel="name"
                    placeholder="Seleccionar Empresa"
                    filter
                    className="userFormDetailDropdown"
                  />
                </div>
              )}

              <h2 className="mt-3 fw-normal userFormDetailTitle">
                Comunicación
              </h2>
              <div className="field col-12 md:col-12">
                <p className="userFormDetailMessage">
                  Es posible que le enviemos correos electrónicos de vez en
                  cuando con actualizaciones y otra información sobre nuestros
                  eventos, productos y servicios que podrían ser de su interés.
                  Puede darse de baja en cualquier momento.
                </p>
              </div>
              <div className="field col-12 md:col-12">{props.buttons}</div>
            </div>
          </form>
        </Card>
      </div>
    </>
  );
};
export default UserFormDetail;
